import { ZClassCommon } from "src/business/classes";
import { ZSpecCommon } from "src/business/specification";

export const getClassSpecs = ({
  primarySchema,
  secondarySchemas,
}: ZClassCommon) => {
  let res: ZSpecCommon[] = [];
  if (primarySchema) res.push(primarySchema);
  if (secondarySchemas) res = [...res, ...secondarySchemas];
  return res;
};
